import Comparision from 'components/Comparision';
import CostSimulation from 'components/CostSimulation';
import { PriceFAQ } from 'components/FAQ';
import Layout from 'components/Layout';
import Price, { TrustSection } from 'components/Price';
import SEO from 'components/seo';
import React from 'react';
import Style from 'styles/components/price.module.scss';

const PricePage = () => {
  return (
    <Layout>
      <SEO title='comachicart' path='price' />
      <div className={Style.priceWrapper}>
        <Price showIntro />
      </div>
      <TrustSection />
      <Comparision />
      <CostSimulation />
      <PriceFAQ />
    </Layout>
  );
};

export default PricePage;
